import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-ai-confirmation-dialog',
  templateUrl: './ai-confirmation-dialog.component.html',
  styleUrl: './ai-confirmation-dialog.component.scss'
})
export class AiConfirmationDialogComponent {
  ImageSrc: any;
  userAnswer: any;
  generatedAnswer: any;
  isProjectDescriptionBasedAnswer: boolean = false;
  prompt: string = '';
  defaultPrompt: string = '.Only want the answer in HTML format.';

  // ✅ Chat history array
  chatHistory: { role: 'user' | 'assistant' | 'system'; content: string }[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { userAnswer: string, generatedAnswer: string, isProjectDescriptionBasedAnswer: boolean },
    private readonly commonService: CommonService,
    private readonly api: ApiUrlHelper,
    private readonly toastr: ToastrService,
    private readonly spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<AiConfirmationDialogComponent>
  ) {
    this.userAnswer = data.userAnswer;
    this.generatedAnswer = data.generatedAnswer;
    this.isProjectDescriptionBasedAnswer = data.isProjectDescriptionBasedAnswer;

    // ✅ Initialize history with system prompt and prior messages
    this.chatHistory.push({
      role: 'system',
      content: 'You are a helpful assistant. Always return answers in HTML format.'
    });

    if (this.userAnswer) {
      this.chatHistory.push({ role: 'user', content: this.userAnswer });
    }

    if (this.generatedAnswer) {
      this.chatHistory.push({ role: 'assistant', content: this.generatedAnswer });
    }
  }

  ngOnInit(): void {}

  generateAnswer() {
    const api = this.api.apiUrl.AI.ChatGPTAPI;

    // ✅ Append new user prompt to history
    this.chatHistory.push({
      role: 'user',
      content: this.prompt + this.defaultPrompt
    });

    const formattedPrompt = this.chatHistory.map(msg => {
      return `${msg.role.toUpperCase()}: ${msg.content}`;
    }).join('\n\n');
  
    const requestedModel = {
      Prompt: formattedPrompt
    };

    this.spinner.show();

    this.commonService.doPost(api, requestedModel).pipe().subscribe({
      next: (response) => {
        this.spinner.hide();

        if (response.success) {
          this.generatedAnswer = response.data;

          // ✅ Store assistant response in history
          this.chatHistory.push({
            role: 'assistant',
            content: response.data
          });
          
          this.prompt = '';
        } else {
          this.toastr.error('No data found!');
        }
      },
      error: () => {
        this.spinner.hide();
        this.toastr.error('Something went wrong!');
      }
    });
  }

  replace() {
    const result = {
      success: true,
      data: this.generatedAnswer
    };

    this.dialogRef.close(result);
  }

  reGenerate() {
    if (!this.prompt?.trim()) {
      this.toastr.error('Please enter a prompt');
      return;
    }

    this.generateAnswer();
  }

  cancel() {
    const result = {
      success: false,
      data: null
    };

    this.dialogRef.close(result);
  }
}
